var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 90,
    viewBox: "0 0 77 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.28363 68.0341L1 71.7424L49.9206 89H75.7359V1H10.6985V12.2674L9.41492 15.1199H6.5624H2.28363L3.85252 25.8168L2.28363 31.5219L4.8509 38.2253L10.6985 42.504L4.8509 46.6402V55.7683L2.28363 57.765V62.329L5.84928 65.0389L2.28363 68.0341Z",
    fill: "#273137",
    fillOpacity: 0.1,
    stroke: "#273137",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAz);
export default __webpack_public_path__ + "static/media/AZ.92cfe1f0a49499b460d1c7c26799e38f.svg";
export { ForwardRef as ReactComponent };